import { TransactionsProvider } from 'contexts/Transactions';
import React, { useEffect, useState } from 'react';
import Transactions from './Transactions';
import { verifyActiveFlag } from '../utils/redirectFlag';
import { parseJwt } from '../utils/decodeJWT';

export const Main = () => {
  const [hasActiveFlag, setHasActiveFlag] = useState(false);

  const handleVerifyFlag = async () => {
    const getToken = parseJwt(`${localStorage.getItem('session-token')}`);
    const memberNumVoeBiz = getToken?.sub.split('|')[2];
    const result = await verifyActiveFlag(memberNumVoeBiz);
    // console.log('result: ', result);
    setHasActiveFlag(result);
  };

  useEffect(() => {
    // console.log('useEffect do handleVerifyFlag');
    handleVerifyFlag();
  }, []);

  if (!hasActiveFlag) {
    return null;
  }

  // console.log('hasActiveFlag: ', hasActiveFlag);

  return (
    <TransactionsProvider>
      <Transactions />
    </TransactionsProvider>
  );
};
